import { DepositModal } from "@loot-os/design-system/domain/DepositModal";

import { useDepositModalContent } from "../lib/depositContent.js";

/**
 * Add funds, mounted once around the routes (`App.tsx`): the design system's `DepositModal`
 * filled by `useDepositModalContent`. Anything opens it with `setDepositOpen(true)` or a link to
 * `?deposit=1`; Stripe's checkout return opens it too, with the payment's state.
 */
export function StoreDeposit() {
  return <DepositModal {...useDepositModalContent()} />;
}
